type ConstructorProps<TDetails> = {
  message: string
  statusCode?: number
  type?: string
  details?: TDetails
}

export class ApiErrorBase<TDetails = unknown> extends Error {
  public readonly message: string
  public readonly type?: string
  public readonly statusCode?: number
  public readonly details?: TDetails

  constructor({ message, type, statusCode, details }: ConstructorProps<TDetails>) {
    super(message)
    this.name = 'ApiError'
    this.type = type
    this.message = message
    this.statusCode = statusCode
    this.details = details
  }

  toString() {
    // let msg = this.message
    // if (this.statusCode && !this.message?.includes(this.statusCode.toString())) {
    //   msg += ` (status: ${this.statusCode})`
    // }
    return this.message?.toString() || 'Unhandled API error'
  }
}
